import { Spacer } from "@/components/Spacer";
import { Link } from "react-router-dom";
export default function Footer({ isMobile }: { isMobile: boolean }) {
  return (
    <div
      id="footer"
      className="w-full flex flex-row justify-center items-center bg-[#1F2126] desktop:py-[76px] desktop:px-[40px] py-[60px] px-[20px]"
    >
      <div className="desktop:w-[960px] w-[342px] flex desktop:flex-row flex-col items-center desktop:items-end desktop:justify-between">
        <div className="flex flex-col items-start justify-start gap-[12px] w-full mb-[32px] desktop:hidden">
          <div className="flex flex-col items-start gap-[2px]">
            <div
              className="font-pre-semibold desktop:text-[15px] text-[13px] leading-[150%] text-[#FFFFFF]"
              style={{ letterSpacing: "-0.3px" }}
            >
              Mediology
            </div>

            <div
              className="font-pre-medium desktop:text-[15px] text-[13px] leading-[150%] text-[#DADFE6] cursor-pointer"
              style={{ letterSpacing: "-0.3px" }}
              onClick={() => {
                window.open("https://www.mediology.ai?lang=en", "_blank");
              }}
            >
              About Us
            </div>
          </div>

          <div className="flex flex-col items-start gap-[2px]">
            <div
              className="font-pre-semibold desktop:text-[15px] text-[13px] leading-[150%] text-[#FFFFFF]"
              style={{ letterSpacing: "-0.3px" }}
            >
              Business
            </div>

            <div
              className="font-pre-medium desktop:text-[15px] text-[13px] leading-[150%] text-[#DADFE6]"
              style={{ letterSpacing: "-0.3px" }}
            >
              corp@mediology.ai
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col items-start">
          <img
            src={"assets/images/footer-logo.png"}
            alt="footer-logo"
            className="desktop:w-[193.26px] desktop:h-[34.27px] desktop:block hidden desktop:mb-[24px]"
          />
          <div className="flex flex-col items-start gap-[4px]">
            <div
              className="font-pre-semibold desktop:text-[15px] text-[13px] leading-[150%] text-[#FFFFFF]"
              style={{ letterSpacing: "-0.3px" }}
            >
              Mediology Co., Ltd.
            </div>
            <div
              className="font-pre-regular desktop:text-[15px] text-[13px] leading-[150%] text-[#DADFE6]"
              style={{ letterSpacing: "-0.3px" }}
            >
              <span className="font-pre-semibold text-[#FFFFFF]">CEO</span> Sara
              Jeong
            </div>
            <div
              className="font-pre-regular desktop:text-[15px] text-[13px] leading-[150%] text-[#DADFE6]"
              style={{ letterSpacing: "-0.3px" }}
            >
              <span className="font-pre-semibold text-[#FFFFFF]">
                Business Registration Number
              </span>{" "}
              520-87-03235
            </div>
            <div
              className="font-pre-regular desktop:text-[15px] text-[13px] leading-[150%] text-[#DADFE6]"
              style={{ letterSpacing: "-0.3px" }}
            >
              (03176) 3F, Blue Cove Square, 27 Gyeonghuigung-gil, Jongno-gu,
              Seoul, South Korea
            </div>
          </div>

          <Spacer height={isMobile ? 32 : 40} />

          <div className="flex flex-col items-start gap-[8px]">
            <div
              className="font-pre-semibold desktop:text-[16px] text-[15px] leading-[150%] text-[#FFFFFF]"
              style={{ letterSpacing: "-0.3px" }}
            >
              <Link to="/en/privacy-policy">Privacy Policy</Link> |{" "}
              <Link to="/en/terms-of-use">Terms of Use</Link>
            </div>

            <div
              className="font-pre-regular desktop:text-[14px] text-[12px] leading-[150%] text-[#DADFE6]"
              style={{ letterSpacing: "-0.3px" }}
            >
              Copyright ⓒ Mediology Co., Ltd. Healthier. All Rights reserved.
            </div>
          </div>
        </div>

        <div className="desktop:flex hidden flex-col items-end justify-between h-[253.27px]">
          <div className="flex flex-row items-center gap-[40px]">
            <div className="flex flex-col items-start gap-[6px]">
              <div
                className="font-pre-semibold desktop:text-[15px] text-[13px] leading-[150%] text-[#FFFFFF]"
                style={{ letterSpacing: "-0.3px" }}
              >
                Mediology
              </div>

              <div
                className="font-pre-medium desktop:text-[15px] leading-[150%] text-[#DADFE6] cursor-pointer"
                style={{ letterSpacing: "-0.3px" }}
                onClick={() => {
                  window.open("https://www.mediology.ai?lang=en", "_blank");
                }}
              >
                About Us
              </div>
            </div>

            <div className="flex flex-col items-start gap-[6px]">
              <div
                className="font-pre-semibold desktop:text-[15px] text-[13px] leading-[150%] text-[#FFFFFF]"
                style={{ letterSpacing: "-0.3px" }}
              >
                Business
              </div>

              <div
                className="font-pre-medium desktop:text-[15px] leading-[150%] text-[#DADFE6]"
                style={{ letterSpacing: "-0.3px" }}
              >
                corp@mediology.ai
              </div>
            </div>
          </div>

          <div className="flex flex-row desktop:justify-end justify-start gap-[10px] desktop:mt-0 mt-[60px]">
            <Sns
              image={"assets/images/instargram.png"}
              link="https://www.instagram.com/healthier_official?igsh=MXh0Z3pyN3phMThvYg=="
            />
            <Sns
              image={"assets/images/kakaotalk.png"}
              link="https://pf.kakao.com/_SxfmyG/chat"
            />
            <Sns
              image={"assets/images/youtube.png"}
              link="https://youtube.com/@healthier_official"
            />
          </div>
        </div>

        <div className="w-full flex flex-row desktop:justify-end justify-start gap-[10px] desktop:mt-0 mt-[50px] desktop:hidden">
          <Sns
            image={"assets/images/instargram.png"}
            link="https://www.instagram.com/healthier_official?igsh=MXh0Z3pyN3phMThvYg=="
          />
          <Sns
            image={"assets/images/kakaotalk.png"}
            link="https://pf.kakao.com/_SxfmyG/chat"
          />
          <Sns
            image={"assets/images/youtube.png"}
            link="https://youtube.com/@healthier_official"
          />
        </div>
      </div>
    </div>
  );
}

const Sns = ({ image, link }: { image: string; link: string }) => {
  return (
    <div className="w-[52px] h-[52px] bg-[#41454E] rounded-[100px] flex items-center justify-center">
      <a href={link} target="_blank" rel="noopener noreferrer">
        <img src={image} alt="sns" className="w-[32px] h-[32px]" />
      </a>
    </div>
  );
};
